var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Manage Git Repositories ")]),
          _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.repositories
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.name",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [
                        _vm._v(" " + _vm._s(item.name) + " "),
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              small: ""
                            },
                            on: {
                              click: function click($event) {
                                return _vm.showDetails(item)
                              }
                            }
                          },
                          [_vm._v("mdi-information")]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function fn(_ref2) {
                      var item = _ref2.item
                      return [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              bottom: "",
                              "offset-y": "",
                              "min-width": "180"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function fn(_ref3) {
                                    var on = _ref3.on,
                                      attrs = _ref3.attrs
                                    return [
                                      _c(
                                        "gg-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                color: "primary"
                                              }
                                            },
                                            "gg-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(" Manage "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                right: ""
                                              }
                                            },
                                            [_vm._v("mdi-chevron-down")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.openEditModal(item)
                                      }
                                    }
                                  },
                                  [_c("v-list-item-title", [_vm._v(" Edit ")])],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.openDeleteModal(item)
                                      }
                                    }
                                  },
                                  [_c("v-list-item-title", [_vm._v("Delete")])],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.basicInformationModal
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.basicInformationModal
            },
            on: {
              close: _vm.hideDetails
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Basic Information ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("b", [_vm._v("Branch information")]),
                              _vm.repositoryToShow.branch !== null
                                ? _c("div", [
                                    _vm._v(" Checked-out Branch: "),
                                    _c("code", [
                                      _vm._v(
                                        _vm._s(_vm.repositoryToShow.branch)
                                      )
                                    ])
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      " No checked-out branch is available. "
                                    )
                                  ]),
                              _vm._l(_vm.repositoryToShow.last_update, function(
                                value,
                                name
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: value
                                  },
                                  [
                                    _c("span", [_vm._v(_vm._s(name))]),
                                    _c("code", [_vm._v(_vm._s(value))])
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("b", [_vm._v("Checkout URL")]),
                              _c(
                                "div",
                                _vm._l(
                                  _vm.repositoryToShow.clone_urls.read_write,
                                  function(item) {
                                    return _c(
                                      "code",
                                      {
                                        key: item
                                      },
                                      [_vm._v(" " + _vm._s(item) + " ")]
                                    )
                                  }
                                ),
                                0
                              )
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("b", [_vm._v("Repository path")]),
                              _c("div", [
                                _c("code", [
                                  _vm._v(
                                    _vm._s(_vm.repositoryToShow.repository_root)
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          on: {
                            click: _vm.hideDetails
                          }
                        },
                        [_vm._v("Close")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1315106325
            )
          })
        : _vm._e(),
      _vm.removeModal
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.removeModal
            },
            on: {
              close: _vm.closeDeleteModal
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Delete repository ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("p", [
                                _c("b", [
                                  _vm._v(
                                    "Are you sure that you want to remove repository from the list of cPanel-managed repositories? "
                                  )
                                ])
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass: "red--text"
                                },
                                [
                                  _vm._v(
                                    " This action only removes the repository from the list of cPanel-managed repositories. The system will not delete the files. To completely delete the repository, manually delete the files after you remove it from the list. "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.closeDeleteModal
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            loading: _vm.deleteLoading,
                            disabled: _vm.deleteLoading
                          },
                          on: {
                            click: _vm.deleteRepository
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3433847344
            )
          })
        : _vm._e(),
      _vm.editModal
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.editModal
            },
            on: {
              close: _vm.closeEditModal
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Edit repository ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Repository Name",
                                  name: "repository-name",
                                  "data-vv-as": "Repository name",
                                  "error-messages": _vm.errors.collect(
                                    "repository-name"
                                  )
                                },
                                model: {
                                  value: _vm.editModel.name,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.editModel, "name", $$v)
                                  },
                                  expression: "editModel.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.repositoryToShow.branch !== null
                            ? _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("gg-select", {
                                    attrs: {
                                      label: "Checked-Out Branch",
                                      items:
                                        _vm.repositoryToShow.available_branches
                                    },
                                    model: {
                                      value: _vm.editModel.branch,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.editModel, "branch", $$v)
                                      },
                                      expression: "editModel.branch"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("b", [_vm._v("Checked-Out Branch")])
                                  ]),
                                  _vm._v(
                                    " The system could not find any branches for this repository. "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.closeEditModal
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            loading: _vm.editLoading,
                            disabled: _vm.editLoading
                          },
                          on: {
                            click: _vm.editRepository
                          }
                        },
                        [_vm._v("Edit")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3982247492
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }